module.exports = __webpack_public_path__ + "static/media/respondant_simple.f0a3f2ce.pdf";